export default {
    isNonEmpty(value, instance, ValidationError) {
        if (value === undefined || value === null || value === '') {
            throw new ValidationError('', 'can not be empty')
        }
    },
    isBoolean(value, instance, ValidationError) {
        if (typeof value !== 'boolean') {
            throw new ValidationError('', 'The value is not a boolean')
        }
    },
    isZeroOrOne(value, instance, ValidationError) {
        let int = parseInt(value)
        if (isNaN(int) || int > 1 || int < 0) {
            throw new ValidationError('', 'Must be 0 or 1')
        }
    },
    isNumeric(value, instance, ValidationError) {
        if (typeof value !== 'number' && !(typeof value === 'string' && !isNaN(value))) {
            throw new ValidationError('', 'The value is not a number')
        }
    },
    isDateYMDFormat(value, instance, ValidationError) {
        if (!value) return
        // check date type first
        const vaildDate = new Date(value)
        if (!(vaildDate instanceof Date && !isNaN(vaildDate))) throw new ValidationError('', 'Please check date format')
        // make simple validation for YYYY-MM-DD format
        let splitString = value.split('-')
        if (splitString.length != 3) throw new ValidationError('', 'Please check date format')
        // deal with some exception like '0023', '08'
        let year = Number(splitString[0])
        let month = Number(splitString[1])
        let day = Number(splitString[2])
        // calculate end of date for month
        let maxDate = new Date(year, month, 0).getDate()

        if (year.toString().length != 4 || month > 12 || month < 0 || day > maxDate || day < 0 || year < 0) {
            throw new ValidationError('', 'Please check date format')
        }
    },
}
